import React from 'react';
import { Helmet } from 'react-helmet';

export default function CleanTextTips() {
  return (
    <main className="container mx-auto px-4 py-12">
      <Helmet>
        <title>Top 5 Ways to Clean Text Data Efficiently | WebUtility Guide</title>
        <meta name="description" content="Explore 5 useful tips to clean and prepare your text for analysis or content creation using WebUtility's Text Cleaner tool." />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">Top 5 Ways to Clean Text Data Efficiently</h1>
      <p className="mb-4 text-gray-600">
        Cleaning text before analysis is crucial for accurate results. Here are the top 5 ways to clean your data using our Text Cleaner tool.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. Remove Extra Spaces</h2>
      <p className="mb-4">Extra spaces can mess up formatting. Use our Text Cleaner to remove duplicate spaces or trim leading/trailing spaces.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. Strip Special Characters</h2>
      <p className="mb-4">Unwanted symbols can be easily removed with our one-click cleaning option.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Convert Text to Lowercase</h2>
      <p className="mb-4">Consistency matters when analyzing. Convert all text to lowercase.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Remove Line Breaks</h2>
      <p className="mb-4">Flatten text by removing line breaks in bulk.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Replace Tabs with Spaces</h2>
      <p>Ensure proper alignment by replacing tabs with consistent spaces.</p>
    </main>
  );
}
